/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Meow Mobile API
 * MeowStore 모바일 백엔드 API 명세
 * OpenAPI spec version: v1.0.0
 */

/**
 * 라운드 코드
 */
export type WorldcupRoundDtoRoundCode = (typeof WorldcupRoundDtoRoundCode)[keyof typeof WorldcupRoundDtoRoundCode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WorldcupRoundDtoRoundCode = {
  R16: 'R16',
  QF: 'QF',
  SF: 'SF',
  THIRD: 'THIRD',
  FINAL: 'FINAL',
} as const;
